
import { useToast } from '@/hooks/use-toast';
import { Member } from '../../types/memberTypes';

export const useOwnershipTransfer = (
  setMembers: React.Dispatch<React.SetStateAction<Member[]>>,
  setEditingMemberId: (id: string | null) => void
) => {
  const { toast } = useToast();
  
  const handleConfirmOwnershipTransfer = (
    memberToPromote: Member | null,
    setMemberToPromote: (member: Member | null) => void,
    setShowTransferOwnershipDialog: (show: boolean) => void
  ) => {
    if (!memberToPromote) return;
    
    // Update roles
    setMembers(prev => prev.map(member => {
      if (member.id === memberToPromote?.id) {
        // New primary owner
        return {
          ...member,
          role: 'Primary Owner',
          permissions: member.permissions?.map(p => ({
            ...p,
            checked: p.id !== 'viewOnly'
          }))
        };
      } else if (member.role === 'Primary Owner') {
        // Demote current primary owner
        return {
          ...member,
          role: 'Owner'
        };
      }
      return member;
    }));
    
    // Show success message
    toast({
      title: 'Ownership Transferred',
      description: `${memberToPromote.firstName} ${memberToPromote.lastName} is now the Primary Owner.`
    });
    
    // Close dialog
    setShowTransferOwnershipDialog(false);
    setMemberToPromote(null);
    setEditingMemberId(null);
  };
  
  return {
    handleConfirmOwnershipTransfer
  };
};
